import { AbstractBluetoothLowEnergyAdapter, BluetoothLowEnergyNamespace } from './AbstractBluetoothLowEnergyAdapter';
import { ATBaseClient } from '@src/services/ATBaseClient';

/**
 * Reaches Bluetooth Low Energy through ATBase, which owns the CandyCane bridge.
 *
 * The namespace doubles as the cross-frame listener name — ATBase registers one listener per role
 * under exactly these names — so a call needs no further routing information.
 */
export class CrossFrameBluetoothLowEnergyAdapter extends AbstractBluetoothLowEnergyAdapter {
    private readonly atBaseClient = new ATBaseClient();

    public call(namespace: BluetoothLowEnergyNamespace, action: string, parameters?: any): Promise<any> {
        return this.atBaseClient.call(namespace, action, parameters || {});
    }
}
